import { render } from "./FollowDemo.vue?vue&type=template&id=40cdb33e&scoped=true"
import script from "./FollowDemo.vue?vue&type=script&lang=js"
export * from "./FollowDemo.vue?vue&type=script&lang=js"

import "./FollowDemo.vue?vue&type=style&index=0&id=40cdb33e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cdb33e"]])

export default __exports__